import BiometricsIcon from '../BiometricsIcon/BiometricsIcon'
import BottomSheet from '../BottomSheet/BottomSheet'
import BottomSheetHeader from '../BottomSheetHeader/BottomSheetHeader'
import LinkButton from '../LinkButton/LinkButton'
import { PrimaryButton } from '../PrimaryButton/PrimaryButton'
import {
  ButtonContainer,
  Container,
  ContentContainer,
  Description,
  IconWrapper,
  Title,
  TitleContainer
} from './BiometricsInitiationBottomSheet.styles'

function mapValue(
  value: number,
  sourceMin: number,
  sourceMax: number,
  targetMin: number,
  targetMax: number,
): number {
  const clampedValue = Math.min(
    Math.max(value, Math.min(sourceMin, sourceMax)),
    Math.max(sourceMin, sourceMax),
  )
  const ratio = (clampedValue - sourceMin) / (sourceMax - sourceMin)
  return targetMin + ratio * (targetMax - targetMin)
}

export type BiometricsInitiationBottomSheetProps = {
  isOpen: boolean
  onSkip: () => void
  onEnable: () => void
  title: string
  titleAvailable: string
  description: string
  enableButtonLabel: string
  skipButtonLabel: string
  safeAreaBottom?: number
}

const BiometricsInitiationBottomSheet = ({
  isOpen,
  onSkip,
  onEnable,
  title,
  titleAvailable,
  description,
  enableButtonLabel,
  skipButtonLabel,
  safeAreaBottom = 0,
}: BiometricsInitiationBottomSheetProps) => {
  const height = mapValue(window.innerHeight, 568, 926, 520, 550)
  const iconMargin = mapValue(window.innerHeight, 568, 926, 8, 10)

  return (
    <BottomSheet
      isOpen={isOpen}
      height={`${height}px`}
      onClose={() => {}}
      header={<BottomSheetHeader title="" />}
    >
      <Container>
        <ContentContainer>
          <IconWrapper $margin={iconMargin}>
            <BiometricsIcon size={106} />
          </IconWrapper>
          <TitleContainer>
            <Title>
              {title}
            </Title>
            <Title>
              {titleAvailable}
            </Title>
          </TitleContainer>
          <Description>
            {description}
          </Description>
        </ContentContainer>
        <ButtonContainer $safeAreaBottom={safeAreaBottom}>
          <PrimaryButton onClick={onEnable}>{enableButtonLabel}</PrimaryButton>
          <LinkButton onClick={onSkip}>{skipButtonLabel}</LinkButton>
        </ButtonContainer>
      </Container>
    </BottomSheet>
  )
}

export default BiometricsInitiationBottomSheet
